import React, { useState, useRef, useEffect, useCallback, useContext } from "react";
import "./CSS/LoginSignup.css";
import { callMultipleApis } from "../services/ApiServices";
import { encryptText } from "../Components/Assets/AppConstant";
import PageLoader from "../Components/Assets/PageLoader/PageLoader";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AuthContext";
import TermsAndConditions from "../Components/tandc/TermsAndConditions";


const getCaptchaKey = process.env.REACT_APP_CAPTCHAKEY_URL;
const customerSignup = process.env.REACT_APP_SIGNUP_URL;
const customerLogin = process.env.REACT_APP_LOGIN_URL;
const securityKeyEndpoint = process.env.REACT_APP_SECURITY_KEY_URL;
const sendOTP = process.env.REACT_APP_SEND_OTP_URL;


const LoginSignup = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  // 🔹 user kis page se aaya tha
  const from = location.state?.from || "/";

  const [otp, setOtp] = useState("");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [error, setError] = useState("");

  const [securityKey, setSecurityKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const isMountedRef = useRef(false);
  const ref = useRef(null);
  const widgetIdRef = useRef(null);
  const tokenRef = useRef(null);
  const pendingSubmitRef = useRef(false);
  const [showTerms, setShowTerms] = React.useState(false);

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    terms: false,
    newsletter: false,
  });
  const toggleScreen = useCallback(() => {
    setIsLogin(!isLogin);
    setErrors({});
    setFormData({
      fullName: "",
      email: "",
      password: "",
      confirmPassword: "",
      phone: "",
      terms: false,
      newsletter: false,
    });
  }, [isLogin]);


  const validate = useCallback(() => {
    const errs = {};
    if (!formData.email) errs.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      errs.email = "Invalid email";

    if (!formData.password) errs.password = "Password is required";

    if (!isLogin) {
      if (!formData.fullName) errs.fullName = "Full Name is required";
      if (!formData.confirmPassword)
        errs.confirmPassword = "Confirm Password is required";
      else if (formData.password !== formData.confirmPassword)
        errs.confirmPassword = "Passwords do not match";
      if (!formData.phone) errs.phone = "Phone is required";
      else if (!/^\d{10}$/.test(formData.phone))
        errs.phone = "Invalid phone number";
      if (!formData.terms) errs.terms = "You must accept Terms & Conditions";
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }, [isLogin, formData]);

  const submitAPI = useCallback(async (token) => {
    try {
      setLoading(true);
      if (validate()) {
        const encryptedPass = encryptText(formData.password, securityKey);
        if (isLogin) {

          const datalogin = {
            email: formData.email,
            password: encryptedPass,
            captchaToken: token
          };

          const [resLogin] = await callMultipleApis([
            {
              url: customerLogin,
              method: "POST",
              data: datalogin,
              params: {},
              headers: {},
            }
          ]);

          if (resLogin.status === true) {
            alert(resLogin.message);
            login(resLogin.result)

            // 🔹 previous page par redirect
            navigate(from, { replace: true });

          } else {
            alert(resLogin.message);
          }
          tokenRef.current = null;
          window.turnstile.reset(widgetIdRef.current);

        } else {
          sendOTPToEmailId(token);
        }
      }

    } catch (error) {
      if (error.response?.status === 403) {
        pendingSubmitRef.current = true;
        window.turnstile.reset(widgetIdRef.current);
      } else {
        alert("Server error. Try again.");
      }
    } finally {
      setLoading(false);
    }
  }, [formData, isLogin, securityKey, toggleScreen, validate]);

  useEffect(() => {
    isMountedRef.current = true;

    const initTurnstile = async () => {
      if (!window.turnstile || !ref.current) return;

      setLoading(true);

      try {
        const [resKey, resSecurityKey] = await callMultipleApis([
          {
            url: getCaptchaKey,
            method: "POST",
            data: {},
            params: {},
            headers: {},
          },
          {
            url: securityKeyEndpoint,
            method: "POST",
            data: {},
            params: {},
            headers: {},
          }
        ]);

        if (!isMountedRef.current) return;

        setSecurityKey(resSecurityKey.result);

        // ✅ Remove old widget if any
        if (widgetIdRef.current && window.turnstile) {
          window.turnstile.remove(widgetIdRef.current);
        }

        // ✅ Always reset ref before creating new widget
        widgetIdRef.current = null;

        // ✅ Render captcha
        widgetIdRef.current = window.turnstile.render(ref.current, {
          sitekey: resKey.result,
          callback: (token) => {
            tokenRef.current = token;
            if (pendingSubmitRef.current) {
              pendingSubmitRef.current = false;
              submitAPI(token);
            }
          },
          "error-callback": () => (tokenRef.current = null),
        });
      } catch (err) {
        console.error("Turnstile error", err);
      } finally {
        setLoading(false);
      }
    };

    initTurnstile();

    return () => {
      isMountedRef.current = false;
      if (widgetIdRef.current && window.turnstile) {
        window.turnstile.remove(widgetIdRef.current);
        widgetIdRef.current = null;
      }
    };
  }, []);

  const sendOTPToEmailId = async (token) => {

    try {
      setLoading(true);
      const data = {
        fullName: formData.fullName,
        email: formData.email,
        otptype: 'REGISTER'
      };

      const config = { 'Authorization': `Bearer ${token}`, };

      const [resOTP] = await callMultipleApis([
        {
          url: sendOTP,
          method: "POST",
          data: data,
          params: {},
          headers: config,
        }
      ]);

      if (resOTP.status === true) {
        alert(resOTP.message);
        setShowOtpModal(true);
      } else {
        alert(resOTP.message);
      }

      tokenRef.current = null;
      window.turnstile.reset(widgetIdRef.current);

    } catch (error) {
      alert("Server error. Try again.");
    } finally {
      setLoading(false);
    }

  }

  const handleResendOtp = async (token) => {
    setOtp("");
    setShowOtpModal(false);
    sendOTPToEmailId(tokenRef.current);
  }

  const verifyOtpAndRegister = async () => {
    try {
      setLoading(true);
      if (otp === "") {
        setError("Enter Your OTP")
      } else {
        setShowOtpModal(false);
        const encryptedPass = encryptText(formData.password, securityKey);

        const data = {
          fullName: formData.fullName,
          email: formData.email,
          password: encryptedPass,
          phone: formData.phone,
          terms: formData.terms,
          newsletter: formData.newsletter,
          emailotp: otp,
          otptype: 'REGISTER'
        };

        const [resSignup] = await callMultipleApis([
          {
            url: customerSignup,
            method: "POST",
            data: data,
            params: {},
            headers: {},
          }
        ]);

        if (resSignup.status === true) {

          alert(resSignup.message);
          setIsLogin(true);
          toggleScreen();
          setFormData({ fullName: "", email: "", password: "", confirmPassword: "", phone: "", terms: false, newsletter: false, });
          setOtp("");

        } else {
          alert(resSignup.message);
          if (resSignup.message === "Please Enter Vaild OTP!") {
            setShowOtpModal(true);
          } else {
            setOtp("");
          }

        }

        tokenRef.current = null;
        window.turnstile.reset(widgetIdRef.current);

      }

    } catch (error) {
      alert("Server error. Try again.");
      setOtp("");
    } finally {
      setLoading(false);
    }

  }


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (!tokenRef.current) {
      //alert("Captcha not verified");
      pendingSubmitRef.current = true;
      // 🔁 Silent refresh
      window.turnstile.reset(widgetIdRef.current);
      return;
    }

    submitAPI(tokenRef.current);

  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">

        {loading && (
          <PageLoader text="" />
        )}

        <h1>{isLogin ? "Login" : "Sign Up"}</h1>

        <form className="loginsignup-fields" onSubmit={handleSubmit}>
          <div className="loginsignup-fields">
            {!isLogin && (
              <>
                <input type="text" name="fullName"
                  placeholder="Full Name"
                  value={formData.fullName || ""}
                  onChange={handleChange} />
                {errors.fullName && <p className="error">{errors.fullName}</p>}
              </>
            )}

            <input type="email" name="email" placeholder="Email Address" value={formData.email || ""} onChange={handleChange} />
            {errors.email && <p className="error">{errors.email}</p>}


            <input type="password" name="password" placeholder="Password" value={formData.password || ""} onChange={handleChange} />
            {errors.password && <p className="error">{errors.password}</p>}

            {!isLogin && (
              <>
                <input type="password" name="confirmPassword" placeholder="Confirm Password" value={formData.confirmPassword || ""} onChange={handleChange} />
                {errors.confirmPassword && (<p className="error">{errors.confirmPassword}</p>)}

                <input type="text" name="phone" placeholder="Phone Number" value={formData.phone || ""} onChange={handleChange}
                />
                {errors.phone && <p className="error">{errors.phone}</p>}

                <div className="loginsignup-agree">
                  <input type="checkbox" id="newsletter" name="newsletter" checked={!!formData.newsletter} onChange={handleChange} />
                  <label htmlFor="newsletter">
                    I agree to receive marketing emails, updates and promotions.
                  </label>
                </div>

                <div className="loginsignup-agree">
                  <input type="checkbox" id="terms" name="terms" checked={!!formData.terms} onChange={handleChange} />
                  <label htmlFor="terms" onClick={() => setShowTerms(true)}>
                    <u>I agree to the terms of use & privacy policy.</u>
                  </label>
                </div>
                {errors.terms && <p className="error">{errors.terms}</p>}


              </>
            )}

          </div>



          <button>{isLogin ? "Login" : "Continue"}</button>
        </form>
        <p className="loginsignup-toggle">
          {isLogin ? "Don't have an account?" : "Already have an account?"}{" "}
          <span onClick={toggleScreen}>
            {isLogin ? "Sign Up here" : "Login here"}
          </span>
        </p>

        <div className="captcha">
          <div ref={ref}></div>
        </div>
      </div>



      {showOtpModal && (
        <div className="otp-overlay">
          <div className="otp-card">

            <button
              className="otp-close-btn"
              onClick={() => setShowOtpModal(false)}
              aria-label="Close"
            >
              ✕
            </button>

            <div className="otp-header">
              <h2>Email Verification</h2>
              <p>
                We’ve sent a 6-digit OTP to <br />
                <strong>{formData.email}</strong>
              </p>
            </div>

            <input
              type="text"
              maxLength="6"
              className="otp-input"
              placeholder="••••••"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
            />

            {error && <div className="otp-error">{error}</div>}

            <button
              className="otp-primary-btn"
              onClick={verifyOtpAndRegister}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Register"}
            </button>

            <button
              className="otp-link-btn"
              onClick={handleResendOtp}
              disabled={loading}
            >
              Resend OTP
            </button>

          </div>
        </div>
      )}

      <TermsAndConditions open={showTerms} onClose={() => setShowTerms(false)} />

    </div>

  );
};

export default LoginSignup;
